// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-item__wrapper[data-v-bdc56440]{display:flex;flex-direction:column;width:100%}.search-item__tags[data-v-bdc56440]{align-items:center;display:flex;height:16px;margin-top:16px}.search-item__meta[data-v-bdc56440]{display:flex;justify-content:space-between;padding-top:8px}.search-item__meta__left[data-v-bdc56440]{align-items:flex-end;display:flex;height:16px}.search-item__meta__left>span+span[data-v-bdc56440]{margin-left:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
